module.exports = "/virtual-football-league/img/amblems/left/logos/Huddersfield.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/virtual-football-league/img/amblems/left/logos/Huddersfield.png
// module id = 2098
// module chunks = 4